export default "__VITE_ASSET__a499775f__"